import React, { Suspense, useState } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import { Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  appRefreshedSelector,
  loggedInSelector,
  appLoadingSelector,
} from 'redux/selectors';

import { TopBar, NavBar } from './components';
import { refreshApp } from 'redux/actions/app';
import Loader from 'components/Loader';
import { drawerWidth, drawerCloseWidth } from './components/NavBar'
import { topbar_height } from './components/TopBar'
import { HomeProvider } from './context'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },

  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    overflowY: 'hidden',
    flex: '1 1 auto',
    marginLeft: drawerWidth,
    marginTop: topbar_height,
    transition: 'all .5s ease',
  },
}));

const HomeLayout = props => {
  const { route, location } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const isLoggedIn = useSelector(loggedInSelector);
  const isRefreshed = useSelector(appRefreshedSelector);
  const isLoading = useSelector(appLoadingSelector);
  const [openDrawer, setOpenDrawer] = useState(false)


  if (!isLoggedIn) {
    return <Redirect to="/auth/login" />;
  }

  if (!isRefreshed) {
    dispatch(refreshApp());
    return <Loader />;
  }

  if (location.pathname == "/api_doc") {
    return <div dangerouslySetInnerHTML={{ __html: apihtml }} />
  }
  return (
    <HomeProvider>
      <div className={classes.root}>
        <TopBar openDrawer={openDrawer} />
        <div className={classes.container}>
          <NavBar openDrawer={openDrawer} setOpenDrawer={setOpenDrawer} />
          <main className={classes.content} style={!openDrawer ? { marginLeft: drawerCloseWidth } : {}}>
            <Suspense fallback={<LinearProgress />}>
              {renderRoutes(route.routes)}
            </Suspense>
          </main>
          {isLoading && <Loader />}
        </div>
      </div>
    </HomeProvider>
  );
};

HomeLayout.propTypes = {
  route: PropTypes.object,
  location: PropTypes.object
};

export default HomeLayout;
let apihtml = `
<!doctype html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>API Espace Client Apave V2.5.1</title>
    <link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css" rel="stylesheet">
    <link href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/monokai-sublime.min.css"
        rel="stylesheet">
    <script src="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/highlight.min.js"></script>
    <script>
        hljs.configure({
            tabReplace: '    ',
        });
        hljs.initHighlightingOnLoad();
    </script>
    <style>
        body {
            position: relative;
        }

        h1 {
            margin-top: 5px;
        }

        h1,
        h2,
        h3,
        h4 {
            color: #2b2b2b;
        }

        h2:after {
            content: ' ';
        }

        h5 {
            font-weight: bold;
        }

        h1 a,
        h2 a,
        h3 a,
        h4 a,
        h5 a,
        h6 a {
            display: none;
            position: absolute;
            margin-left: 8px;
        }

        h1:hover a,
        h2:hover a,
        h3:hover a,
        h4:hover a,
        h5:hover a,
        h6:hover a {
            color: #a5a5a5;
            display: initial;
        }

        .nav.nav-tabs>li>a {
            padding-top: 4px;
            padding-bottom: 4px;
        }

        .tab-content {
            padding-top: 8px;
        }

        .table {
            margin-bottom: 8px;
        }

        pre {
            border-radius: 0px;
            border: none;
        }

        pre code {
            margin: -9.5px;
        }

        .request {
            margin-top: 12px;
            margin-bottom: 24px;
        }

        .response-text-sample {
            padding: 0px !important;
        }

        .response-text-sample pre {
            margin-bottom: 0px;
        }


        #sidebar-wrapper {
            z-index: 1000;
            position: fixed;
            left: 250px;
            width: 250px;
            height: 100%;
            margin-left: -250px;
            overflow-y: auto;
            overflow-x: hidden;
            background: #2b2b2b;
            padding-top: 20px;
        }

        #sidebar-wrapper ul {
            width: 250px;
        }

        #sidebar-wrapper ul li {
            margin-right: 10px;
        }

        #sidebar-wrapper ul li a:hover {
            background: inherit;
            text-decoration: none;
        }

        #sidebar-wrapper ul li a {
            display: block;
            color: #ECF0F1;
            padding: 6px 15px;
        }

        #sidebar-wrapper ul li ul {
            padding-left: 25px;
        }

        #sidebar-wrapper ul li ul li a {
            padding: 1px 0px;
        }

        #sidebar-wrapper ul li a:hover,
        #sidebar-wrapper ul li a:focus {
            color: #e0c46c;
            border-right: solid 1px #e0c46c;
        }

        #sidebar-wrapper ul li.active>a {
            color: #e0c46c;
            border-right: solid 3px #e0c46c;
        }

        #sidebar-wrapper ul li:not(.active) ul {
            display: none;
        }

        #page-content-wrapper {
            width: 100%;
            position: absolute;
            padding: 15px 15px 15px 250px;
        }
    </style>
</head>

<body data-spy="scroll" data-target=".scrollspy">
    <div id="sidebar-wrapper">
        <div class="scrollspy">
            <ul id="main-menu" data-spy="affix" class="nav">
                <li>
                    <a href="#doc-general-notes">General notes</a>
                </li>

                <li>
                    <a href="#doc-api-detail">API detail</a>
                </li>

                <li>
                    <a href="#request-access-token-post">Access Token (POST)</a>
                </li>

                <li>
                    <a href="#request-access-token-get">Access Token (GET)</a>
                </li>

                <li>
                    <a href="#request-refresh-token">Refresh Token</a>
                </li>

                <li>
                    <a href="#request-list-sessions">List Session Catalogues</a>
                </li>

                <li>
                    <a href="#request-create-session">Create Session Catalogue</a>
                </li>

                <li>
                    <a href="#request-update-session">Update Session Catalogue</a>
                </li>

                <li>
                    <a href="#request-delete-session">Delete Session Catalogue</a>
                </li>

                <li>
                    <a href="#request-list-products">List Products</a>
                </li>

                <li>
                    <a href="#request-create-product">Create or Update Product</a>
                </li>

                <li>
                    <a href="#request-delete-product">Delete Product</a>
                </li>

                <li>
                    <a href="#request-list-locations">List Locations</a>
                </li>

                <li>
                    <a href="#request-create-locations">Create or Update Location</a>
                </li>

                <li>
                    <a href="#request-delete-locations">Delete Location</a>
                </li>

                <li>
                    <a href="#request-create-caracteristiques">Create or Update Livrables Rapportage SEL</a>
                </li>

                <li>
                    <a href="#request-delete-caracteristiques">Delete Livrables Rapportage SEL</a>
                </li>

                <li>
                    <a href="#request-create-compteSel">Create or Update CompteSel</a>
                </li>

                <li>
                    <a href="#request-delete-compteSel">Delete CompteSel</a>
                </li>

                <li>
                    <a href="#request-create-equipements">Create or Update Equipement</a>
                </li>

                <li>
                    <a href="#request-delete-equipements">Delete Equipement</a>
                </li>

                <li>
                    <a href="#request-create-interventionSel">Create or Update InterventionSel</a>
                </li>

                <li>
                    <a href="#request-delete-interventionSel">Delete InterventionSel</a>
                </li>

                <li>
                    <a href="#request-create-offre">Create or Update Offre</a>
                </li>

                <li>
                    <a href="#request-delete-offre">Delete Offre</a>
                </li>

                <li>
                    <a href="#request-create-facture">Create or Update Factures</a>
                </li>

                <li>
                    <a href="#request-delete-facture">Delete Facture</a>
                </li>
            </ul>
        </div>

    </div>
    <div id="page-content-wrapper">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <h1>API Espace Client Apave V2.5.1</h1>

                    <h2 id="doc-general-notes">
                        General notes
                        <a href="#doc-general-notes"><i class="glyphicon glyphicon-link"></i></a>
                    </h2>

                    <p><strong>Bearer Authentication</strong></p>
                    <p>
                        Bearer authentication (also called token authentication) is an HTTP authentication scheme that
                        involves security tokens called bearer tokens. The bearer token is a cryptic string,
                        usually generated by the server in response to a login request. <br>The client must send this
                        token in the Authorization header when making requests to protected resources:
                    </p>
                    <div>
                        <pre><code class="hljs curl"><strong>Authorization: Bearer {token}</strong></code></pre>
                    </div>
                    <p><strong>TEST BASE_URL:</strong> https://console-espaceclient-rec.apavetest.com/api</p>
                    <p><strong>STAGING BASE_URL:</strong> https://console-espaceclient-pp.apavetest.com/api</p>
                    <p><strong>LIVE BASE_URL:</strong> https://console-espaceclient.apave.com/api</p>

                    <p><strong>Duration</strong>&nbsp;&nbsp;10 hours</p>
                    <p><strong>Sequence for Refresh</strong>&nbsp;&nbsp;7 days</p>
                    <br />
                    <p><strong>Filter Rules</strong></p>
                    <p>
                        use & for multiple fields filtering
                    <pre><code class="hljs curl">[Field Name]=[value]</code></pre>
                    </p>
                    <p><strong>Sort Rules</strong></p>
                    <p>
                        use | for multiple fields sorting, and - for desc, + for asc
                    <pre><code class="hljs curl">sort=[+|-][Field Name1]|[+|-][Field Name2]...</code></pre>
                    </p>
                    <p>
                        For example:
                    <pre><code class="hljs curl">/sessions?status=true&price=10&sort=-date|+price</code></pre>
                    </p>
                    <p><strong>Pagination Rules</strong></p>
                    <p>
                    <pre><code class="hljs curl">offset: the number of first "save" to be returned (not compulsory, by default 0)<br/>limit: a number of documents to be returned (not compulsory, by default 50)</code></pre>
                    </p>
                    <br />
                    <p><strong>Error Status</strong></p>
                    <p>
                    <pre><code class="hljs curl"><br/>200: Success <br/>400: Bad Request <br/>401: Unauthorized <br/>403: Forbidden <br/>500: Internal Server Error
                    </code></pre>
                    </p>




                    <h2 id="doc-api-detail">
                        API detail
                        <a href="#doc-api-detail"><i class="glyphicon glyphicon-link"></i></a>
                    </h2>



                    <div class="request">

                        <h3 id="request-access-token-post">
                            Access Token (POST)
                            <a href="#request-access-token-post"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>This is the token that is used in the Authorization header for all requests in the API.
                            </p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-access-token-post-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-access-token-post-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-access-token-post-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -H "Content-Type: application/x-www-form-urlencoded" -d "clientId=60253916e4a09214f05baa50&clientSecret=a18269dafd6ae44d0192a12f4f24dabd" "{{BASE_URL}}/oauth/token"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-access-token-post-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/oauth/token HTTP/1.1
Host: 
Content-Type: application/x-www-form-urlencoded

clientId=60253916e4a09214f05baa50&clientSecret=a18269dafd6ae44d0192a12f4f24dabd</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-access-token-get">
                            Access Token (GET)
                            <a href="#request-access-token-get"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>This is the token that is used in the Authorization header for all requests in the API.
                            </p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-access-token-get-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-access-token-get-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-access-token-get-example-curl">
                                    <pre><code class="hljs curl">curl -X GET "{{BASE_URL}}/oauth/token?clientId=60253916e4a09214f05baa50&clientSecret=a18269dafd6ae44d0192a12f4f24dabd"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-access-token-get-example-http">
                                    <pre><code class="hljs http">GET {{BASE_URL}}/oauth/token?clientId=60253916e4a09214f05baa50&clientSecret=a18269dafd6ae44d0192a12f4f24dabd HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-refresh-token">
                            Refresh Token
                            <a href="#request-refresh-token"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>refresh authentication token and return new one</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-refresh-token-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-refresh-token-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-refresh-token-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -H "Content-Type: application/x-www-form-urlencoded" -d "refreshToken=60253916e4a09214f05baa50.892a1ac31d1ec06de463153acb0e8c5ce1fc9a4d23f1560dc2c4476cc80b60449e7a533584f3f4dd" "{{BASE_URL}}/oauth/refresh-token"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-refresh-token-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/oauth/refresh-token HTTP/1.1
Host: 
Content-Type: application/x-www-form-urlencoded

refreshToken=60253916e4a09214f05baa50.892a1ac31d1ec06de463153acb0e8c5ce1fc9a4d23f1560dc2c4476cc80b60449e7a533584f3f4dd</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-list-sessions">
                            List Session Catalogues
                            <a href="#request-list-sessions"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>return session catalogues</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-list-sessions-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-list-sessions-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-list-sessions-example-curl">
                                    <pre><code class="hljs curl">curl -X GET "{{BASE_URL}}/exposee/v1/sessions?offset=0&limit=50"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-list-sessions-example-http">
                                    <pre><code class="hljs http">GET {{BASE_URL}}/exposee/v1/sessions?offset=0&limit=50 HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-create-session">
                            Create Session Catalogue
                            <a href="#request-create-session"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new session catalogue</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-session-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-create-session-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-session-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '{      
    "sessionId": "string", // required
    "CodeProduct": "string", 
    "mode": "Inter"
    "title": "string",
    "startDate": "date",
    "endDate": "date",
    "Idlieu": "string",
    "center": "string",
    "places": 2,
    "prix": "string",
    "status": "string",
    "stateCode": "number",
    "stateLabel": "string"
}' "{{BASE_URL}}/exposee/v1/sessions"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-session-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/sessions HTTP/1.1
Host: 

{
    "sessionId": "string", // required
    "CodeProduct": "string",
    "mode": "Inter"
    "title": "string",
    "startDate": "date",
    "endDate": "date",
    "Idlieu": "string",
    "center": "string",
    "places": 2,
    "prix": "string",
    "status": "string",
    "stateCode": "number",
    "stateLabel": "string"
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-update-session">
                            Update Session Catalogue
                            <a href="#request-update-session"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>update session catalogue</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-update-session-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-update-session-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-update-session-example-curl">
                                    <pre><code class="hljs curl">curl -X PATCH -d '{
    "CodeProduct": "string",
    "mode": "Inter"
    "title": "string",
    "startDate": "date",
    "endDate": "date",
    "Idlieu": "string",
    "center": "string",
    "places": 2,
    "prix": "string",
    "status": "string",
    "stateCode": "number",
    "stateLabel": "string",
}' "{{BASE_URL}}/exposee/v1/sessions/{{sessionId}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-update-session-example-http">
                                    <pre><code class="hljs http">PATCH {{BASE_URL}}/exposee/v1/sessions/{{sessionId}} HTTP/1.1
Host: 

{
    "CodeProduct": "string",
    "mode": "Inter"
    "title": "string",
    "startDate": "date",
    "endDate": "date",
    "Idlieu": "string",
    "center": "string",
    "places": 2,
    "prix": "string",
    "status": "string",
    "stateCode": "number",
    "stateLabel": "string",
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-delete-session">
                            Delete Session Catalogue
                            <a href="#request-delete-session"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete session datalogue</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-session-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-delete-session-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-session-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/sessions/{{sessionId}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-session-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/sessions/{{sessionId}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-list-products">
                            List Products
                            <a href="#request-list-products"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>return products</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-list-products-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-list-products-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-list-products-example-curl">
                                    <pre><code class="hljs curl">curl -X GET "{{BASE_URL}}/exposee/v1/products?offset=0&limit=50"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-list-products-example-http">
                                    <pre><code class="hljs http">GET {{BASE_URL}}/exposee/v1/products?offset=0&limit=50 HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-create-product">
                            Create or Update Product
                            <a href="#request-create-product"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new product or update a product with same idProduit</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-product-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-create-product-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-product-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
  "generalite": {
      "idProduit": "string", //required
      "idProduitMetier": "string",
      "versionProduit": "string",
      "langue": "string",
      "codeProduitCatalogue": "string",
      "codeProduit": "string",
      "typeProduit": {
          "code": "00"
      },
      "descriptifGeneralInterne": "string",
      "libelleComplet": "string",
      "libelleClient": "string",
      "libelleCourt": "string",
      "codeDomaine": {
        "code": "00"
      },
      "codeChamp": {
        "code": "00"
      },
      "codeFamille": {
          "code": "00"
      },
      "flagProduitInterne": false,
      "societesDeCommercialisations": [{
          "codeSociete": "string"
      }],
      "responsableProduit": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "estStage": false,
      "statutProduit": "EC",
      "gestionAvancement": false
  },
  "environnement": {
      "modules": [{
          "codeModule": "string",
          "libelleModule": "string",
          "idModuleMetier": "string",
          "qualificationsModules": [{
              "codeQualification": "string"
          }],
          "dateRetraitModuleProduit": "date",
          "moduleFormation": {
              "infosCategories": [{
                  "idMetierCategorie": "string",
                  "typeCertificat": {"code": "string"},
                  "certificat": {"code": "string"},
                  "categorie": {"code": "string"},
              }],
              "natureModule": {"code": "string"},
              "dureeJour": "string",
              "dureeJourCentieme": {"code": "string"},
              "dureeHeures": "string",
              "dureeHeuresCentieme": {"code": "string"},
              "uniteFacturation": {"code": "string"},
              "effectifPreconise": 1,
              "saisieResultat": false,
              "commentaireObligatoireFavorable": false,
              "commentaireObligatoireDefavorable": false,
              "modeIntraUniquement": false,
              "maxiPreconise": "string",
              "miniPreconise": "string"

          },
          "moduleHorsFormation": {
              "descriptifGeneralInterne": "string",
              "documentsModuleAssocie": [{
                  "idGedApave": "string",
                  "classeDocumentaire": "string",
                  "natureDocument": "string",
                  "dateDuDocument": "date",
                  "libelle": "string",
                  "referenceApave": "string",
                  "version": "string"
              }]
          },
          "commentaireRessourcesHumaines": "string",
          "profilsIntervenants": "string",
          "modulesFormationEtSecurite": "string",
          "commentaireAutresDonnees": "string",
          "reconnaissancesExternes": [],
          "codeApaveAlsace": "string",
          "codeApaveNordOuest": "string",
          "codeApaveParis": "string",
          "codeApaveSudeurope": "string",
          "commentaireParametrageSi": "string",
          "dateDerniereModification": "datetime",
          "typesLivrables": [{
              "codeTypeLivrable": "string",
              "designationTypeLivrable": "string",
              "nature": "string",
              "quantite": "string"
          }],
          "typesSupportsSaisies": [{
              "codeSupportSaisie": "string"
          }]
      }],
      "solutionProduit": "string",
      "produitsInternesAssocies": [{
          "codeProduit": "string"
      }],
      "documentsProduit": [{
          "idGedApave": "string",
          "classeDocumentaire": "string",
          "natureDocument": "string",
          "dateDuDocument": "datetime",
          "libelle": "string",
          "referenceApave": "string",
          "version": "string"
      }],
      "choixModuleObligatoire": false
  },
  "donneeCommerciale": {
      "produitReachat": "string",
      "ptc": false,
      "plusValueFacturations": ["string"],
      "aidesAuChiffrages": [{
          "codeAide": "string",
          "typeAide": "string",
          "designationAide": "string"
      }],
      "consigneInterneCommercialisation": "string",
      "complementConsigneCommerciale": "string",
      "referenceCommerciale": "string"
  },
  "marketingWeb": {
      "rattachementsMarches": [],
      "rattachementMetier": {
          "code": "00"
      },
      "secteursActivitesClients": ["string"],
      "besoins": ["string"],
      "themesBiensEquipements": ["string"],
      "pitch": "string",
      "objectif": "string",
      "descriptif": "string",
      "publieClient": false,
      "dateMiseADispoGP": "date",
      "dateFinMiseDispoGP": "date",
      "periodiciteExpliqueeAuClient": "string",
      "contexteReglementaire": "string",
      "atout": "string",
      "aLaUne": false,
      "boost": 1,
      "prestationsConnexes": [{
          "codeProduit": "string"
      }]
  },
  "ressourceHumaine": {
      "commentaireQualification": "string",
      "qualificationsProduits": [{
          "codeQualification": "string"
      }],
      "produitDangereux": false
  },
  "formationProfessionnelle": {
      "donneeCommerciale": {
          "lePlusApave": "string",
          "prixParStagiaire": "string",
          "devisePrixParStagiaire": {"code": "string"},
          "formationIntraUniquement": false,
          "consignesAuxCentresPlanification": "string",
          "nbStagiaireMaxi": 1,
          "nbStagiaireMini": 1,
          "dureeValiditeeDocumentDelivre": {
              "duree": "string",
              "unite": {"code": "string"},
          },
          "typeDeValidite": {"code": "string"},
          "typeDePhrasier": {"code": "string"},
          "phrasier": {"code": "string"},
          "actionHorsFormationProfessionnelle": false,
          "formationEligibleCpf": false,
          "referenceCPF": "string"
      },
      "generalite": {
          "codeProduitRattachement": "string",
          "objectifStage": "string",
          "detailProgramme": "string",
          "millesimeCatalogue": "string",
          "dureeJour": "string",
          "dureeJourCentieme": {
            "code": "00"
           },
          "dureeHeures": "string",
          "dureeHeuresCentieme": {
            "code": "00"
          },
          "dureeFicheProgramme": "string",
          "langueAnimation": "string",
          "modeAnimation": {
            "code": "00"
            },
          "natureDesActionsFormation": "string",
          "prerequis": "string",
          "publicConcerne": "string",
          "modaliteEvaluationDesAcquis": "string",
          "documentDelivreEvaluationAcquis": "string",
          "categorieStage": {"code": "string"},
          "formacode": "string",
          "centreFormationDedie": "string",
          "moyenPedagogique": "string",
          "profilFormateur": "string"
      },
      "parametrage": {
          "eligibiliteAptisSel": false,
          "stageNonAdaptable": false,
          "donneeLegacy": {
              "dateDebutValiditeMissionGlobale": "date"
          }
      }
  },
  "donneeTechnique": {
      "fdpModifiable": false,
      "incompatibiliteDeontologique": false,
      "dureeArchivage": 1,
      "reconnaissancesExternes": ["string"],
      "detailDeLaReconnaissance": "string"
  },
  "tracesEnregistrements": [{
      "operation": "C",
      "date": "date",
      "utilisateur": "string"
  }],
  "parametrage": {
      "estSoumisATVAImmobiliere": false,
      "dateCreationVersion": "date",
      "dateDerniereModification": "date",
      "dateFinVersion": "date",
      "dateDeDebutDeValidite": "date",
      "dateDeFinDeValidite": "date",
      "trameOffre": {
          "code": "00"
       },
      "dateValidation":"date",
      "creePar": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "modifiePar": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "codeApaveAlsace": "string",
      "codeApaveNordOuest": "string",
      "codeApaveParis": "string",
      "codeApaveSudeurope": "string",
      "miseDispositionOffreIntervenant": false,
      "periodiciteReglementaireProduit": {
        "code": "00"
      },
      "typesEquipementsProduits": [{
          "typeEquipement": "string",
          "periodiciteReglementaireEquipement": "string"
      }],
      "produitNonPlanifie": false,
      "suiviMissionChargeAffairesCld": false,
      "eligibiliteFacturationAutomatique": false,
      "emissionAvisIntervention": false,
      "recurrenceMission": {
        "code": "00"
      },
      "conditionFacturationRecurrent": {"code":"string"},
      "conditionDeFacturationNonRecurrent": {"code":"string"},
      "prixVenteReference": 100,
      "donneeLegacy": {
          "codeProduitHera": "string",
          "transfertSiDuLem": false,
          "codeFamilleSlog": "string",
          "codeProduitSlog": {"code": "string"},
          "codeMetierTabocom": {
                "code": "00"
          },
          "classificationTabocom": {
            "code": "00"
          },
          "typeSessionTabocom": {
            "code": "00"
          },
          "modeGenerationTache": {
            "code": "00"
          },
          "applicationMinimumIntervention": false,
          "editionEquipementPossible": false

      },
      "typesLivrables": [{
          "codeTypeLivrable": "string",
          "designationTypeLivrable": "string",
          "nature": "string",
          "quantite": "string"
      }],
      "typesSupportsDeSaisies": [{
          "codeSupportSaisie": "string",
          "designationSupportSaisie": "string",
          "nature": "string",
          "quantite": "string"
      }]
  }
}' "{{BASE_URL}}/exposee/v1/products"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-product-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/products HTTP/1.1
Host: 


{
  "generalite": {
      "idProduit": "string", //required
      "idProduitMetier": "string",
      "versionProduit": "string",
      "langue": "string",
      "codeProduitCatalogue": "string",
      "codeProduit": "string",
      "typeProduit": {
          "code": "00"
      },
      "descriptifGeneralInterne": "string",
      "libelleComplet": "string",
      "libelleClient": "string",
      "libelleCourt": "string",
      "codeDomaine": {
        "code": "00"
      },
      "codeChamp": {
        "code": "00"
      },
      "codeFamille": {
          "code": "00"
      },
      "flagProduitInterne": false,
      "societesDeCommercialisations": [{
          "codeSociete": "string"
      }],
      "responsableProduit": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "estStage": false,
      "statutProduit": "EC",
      "gestionAvancement": false
  },
  "environnement": {
      "modules": [{
          "codeModule": "string",
          "libelleModule": "string",
          "idModuleMetier": "string",
          "qualificationsModules": [{
              "codeQualification": "string"
          }],
          "dateRetraitModuleProduit": "date",
          "moduleFormation": {
              "infosCategories": [{
                  "idMetierCategorie": "string",
                  "typeCertificat": {"code": "string"},
                  "certificat": {"code": "string"},
                  "categorie": {"code": "string"},
              }],
              "natureModule": {"code": "string"},
              "dureeJour": "string",
              "dureeJourCentieme": {"code": "string"},
              "dureeHeures": "string",
              "dureeHeuresCentieme": {"code": "string"},
              "uniteFacturation": {"code": "string"},
              "effectifPreconise": 1,
              "saisieResultat": false,
              "commentaireObligatoireFavorable": false,
              "commentaireObligatoireDefavorable": false,
              "modeIntraUniquement": false,
              "maxiPreconise": "string",
              "miniPreconise": "string"

          },
          "moduleHorsFormation": {
              "descriptifGeneralInterne": "string",
              "documentsModuleAssocie": [{
                  "idGedApave": "string",
                  "classeDocumentaire": "string",
                  "natureDocument": "string",
                  "dateDuDocument": "date",
                  "libelle": "string",
                  "referenceApave": "string",
                  "version": "string"
              }]
          },
          "commentaireRessourcesHumaines": "string",
          "profilsIntervenants": "string",
          "modulesFormationEtSecurite": "string",
          "commentaireAutresDonnees": "string",
          "reconnaissancesExternes": [],
          "codeApaveAlsace": "string",
          "codeApaveNordOuest": "string",
          "codeApaveParis": "string",
          "codeApaveSudeurope": "string",
          "commentaireParametrageSi": "string",
          "dateDerniereModification": "datetime",
          "typesLivrables": [{
              "codeTypeLivrable": "string",
              "designationTypeLivrable": "string",
              "nature": "string",
              "quantite": "string"
          }],
          "typesSupportsSaisies": [{
              "codeSupportSaisie": "string"
          }]
      }],
      "solutionProduit": "string",
      "produitsInternesAssocies": [{
          "codeProduit": "string"
      }],
      "documentsProduit": [{
          "idGedApave": "string",
          "classeDocumentaire": "string",
          "natureDocument": "string",
          "dateDuDocument": "datetime",
          "libelle": "string",
          "referenceApave": "string",
          "version": "string"
      }],
      "choixModuleObligatoire": false
  },
  "donneeCommerciale": {
      "produitReachat": "string",
      "ptc": false,
      "plusValueFacturations": ["string"],
      "aidesAuChiffrages": [{
          "codeAide": "string",
          "typeAide": "string",
          "designationAide": "string"
      }],
      "consigneInterneCommercialisation": "string",
      "complementConsigneCommerciale": "string",
      "referenceCommerciale": "string"
  },
  "marketingWeb": {
      "rattachementsMarches": [],
      "rattachementMetier": {
          "code": "00"
      },
      "secteursActivitesClients": ["string"],
      "besoins": ["string"],
      "themesBiensEquipements": ["string"],
      "pitch": "string",
      "objectif": "string",
      "descriptif": "string",
      "publieClient": false,
      "dateMiseADispoGP": "date",
      "dateFinMiseDispoGP": "date",
      "periodiciteExpliqueeAuClient": "string",
      "contexteReglementaire": "string",
      "atout": "string",
      "aLaUne": false,
      "boost": 1,
      "prestationsConnexes": [{
          "codeProduit": "string"
      }]
  },
  "ressourceHumaine": {
      "commentaireQualification": "string",
      "qualificationsProduits": [{
          "codeQualification": "string"
      }],
      "produitDangereux": false
  },
  "formationProfessionnelle": {
      "donneeCommerciale": {
          "lePlusApave": "string",
          "prixParStagiaire": "string",
          "devisePrixParStagiaire": {"code": "string"},
          "formationIntraUniquement": false,
          "consignesAuxCentresPlanification": "string",
          "nbStagiaireMaxi": 1,
          "nbStagiaireMini": 1,
          "dureeValiditeeDocumentDelivre": {
              "duree": "string",
              "unite": {"code": "string"},
          },
          "typeDeValidite":{"code": "string"},
          "typeDePhrasier": {"code": "string"},
          "phrasier": {"code": "string"},
          "actionHorsFormationProfessionnelle": false,
          "formationEligibleCpf": false,
          "referenceCPF": "string"
      },
      "generalite": {
          "codeProduitRattachement": "string",
          "objectifStage": "string",
          "detailProgramme": "string",
          "millesimeCatalogue": "string",
          "dureeJour": "string",
          "dureeJourCentieme": {
            "code": "00"
           },
          "dureeHeures": "string",
          "dureeHeuresCentieme": {
            "code": "00"
          },
          "dureeFicheProgramme": "string",
          "langueAnimation": "string",
          "modeAnimation": {
            "code": "00"
            },
          "natureDesActionsFormation": "string",
          "prerequis": "string",
          "publicConcerne": "string",
          "modaliteEvaluationDesAcquis": "string",
          "documentDelivreEvaluationAcquis": "string",
          "categorieStage": {"code": "string"},
          "formacode": "string",
          "centreFormationDedie": "string",
          "moyenPedagogique": "string",
          "profilFormateur": "string"
      },
      "parametrage": {
          "eligibiliteAptisSel": false,
          "stageNonAdaptable": false,
          "donneeLegacy": {
              "dateDebutValiditeMissionGlobale": "date"
          }
      }
  },
  "donneeTechnique": {
      "fdpModifiable": false,
      "incompatibiliteDeontologique": false,
      "dureeArchivage": 1,
      "reconnaissancesExternes": ["string"],
      "detailDeLaReconnaissance": "string"
  },
  "tracesEnregistrements": [{
      "operation": "C",
      "date": "date",
      "utilisateur": "string"
  }],
  "parametrage": {
      "estSoumisATVAImmobiliere": false,
      "dateCreationVersion": "date",
      "dateDerniereModification": "date",
      "dateFinVersion": "date",
      "dateDeDebutDeValidite": "date",
      "dateDeFinDeValidite": "date",
      "trameOffre": {
          "code": "00"
       },
      "dateValidation":"date",
      "creePar": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "modifiePar": {
          "codeCollaborateur": "string",
          "codeSociete": "string",
          "matricule": "string",
          "codeEntite": "string"
      },
      "codeApaveAlsace": "string",
      "codeApaveNordOuest": "string",
      "codeApaveParis": "string",
      "codeApaveSudeurope": "string",
      "miseDispositionOffreIntervenant": false,
      "periodiciteReglementaireProduit": {
        "code": "00"
      },
      "typesEquipementsProduits": [{
          "typeEquipement": "string",
          "periodiciteReglementaireEquipement": "string"
      }],
      "produitNonPlanifie": false,
      "suiviMissionChargeAffairesCld": false,
      "eligibiliteFacturationAutomatique": false,
      "emissionAvisIntervention": false,
      "recurrenceMission": {
        "code": "00"
      },
      "conditionFacturationRecurrent": {"code":"string"},
      "conditionDeFacturationNonRecurrent": {"code":"string"},
      "prixVenteReference": 100,
      "donneeLegacy": {
          "codeProduitHera": "string",
          "transfertSiDuLem": false,
          "codeFamilleSlog": "string",
          "codeProduitSlog": {"code": "string"},
          "codeMetierTabocom": {
                "code": "00"
          },
          "classificationTabocom": {
            "code": "00"
          },
          "typeSessionTabocom": {
            "code": "00"
          },
          "modeGenerationTache": {
            "code": "00"
          },
          "applicationMinimumIntervention": false,
          "editionEquipementPossible": false

      },
      "typesLivrables": [{
          "codeTypeLivrable": "string",
          "designationTypeLivrable": "string",
          "nature": "string",
          "quantite": "string"
      }],
      "typesSupportsDeSaisies": [{
          "codeSupportSaisie": "string",
          "designationSupportSaisie": "string",
          "nature": "string",
          "quantite": "string"
      }]
  }
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-product">
                            Delete Product
                            <a href="#request-delete-product"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete product</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-product-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-delete-product-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-product-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/products/{{PRODUCT_ID}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-product-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/products/{{PRODUCT_ID}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-list-locations">
                            List Locations
                            <a href="#request-list-locations"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>return locations</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-list-locations-example-curl"
                                        data-toggle="tab">Curl</a></li>
                                <li role="presentation"><a href="#request-list-locations-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-list-locations-example-curl">
                                    <pre><code class="hljs curl">curl -X GET "{{BASE_URL}}/exposee/v1/locations?offset=0&limit=50"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-list-locations-example-http">
                                    <pre><code class="hljs http">GET {{BASE_URL}}/exposee/v1/locations?offset=0&limit=50 HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>
                    <div class="request">

                        <h3 id="request-create-locations">
                            Create or Update Location
                            <a href="#request-create-locations"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new location or update a location with same id</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-locations-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-locations-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-locations-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "Idlieu": "string", // required
    "Codelieu": "string",
    "title": "string",
    "address1": "string",
    "address2": "string",
    "address3": "string",
    "postalCode": "string",
    "city": "string",
    "lat": "string",
    "lon": "string",
    "countryCode": "string",
    "tel": "string",
    "fax": "string",
    "email": "string",
    "idagence": "string",
    "related_lieu": "string",
    "related_code": "string",
    "flag_designer": "string",
    "flag_apave": "string",
    "pan": "string",
    "gedId": "string",
    "Region_ID_New": "string",
    "Region_Title_Ne": "string"
}' "{{BASE_URL}}/exposee/v1/locations"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-locations-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/locations HTTP/1.1
Host: 


{
    "Idlieu": "string", // required
    "Codelieu": "string",
    "title": "string",
    "address1": "string",
    "address2": "string",
    "address3": "string",
    "postalCode": "string",
    "city": "string",
    "lat": "string",
    "lon": "string",
    "countryCode": "string",
    "tel": "string",
    "fax": "string",
    "email": "string",
    "idagence": "string",
    "related_lieu": "string",
    "related_code": "string",
    "flag_designer": "string",
    "flag_apave": "string",
    "pan": "string",
    "gedId": "string",
    "Region_ID_New": "string",
    "Region_Title_Ne": "string"
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-locations">
                            Delete Location
                            <a href="#request-delete-locations"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete location</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-locations-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-locations-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-locations-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/locations/{{Idlieud}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-locations-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/locations/{{Idlieu}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-create-caracteristiques">
                            Create or Update Livrables Rapportage SEL
                            <a href="#request-create-caracteristiques"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new data or update with same idCompteSel</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-create-caracteristiques-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-caracteristiques-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-caracteristiques-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "idCompteSel": "idCompteSel", //required
    "donneesRapport": {
        "versionLivrableRapportage": "string",
        "libelleFichierLivrableRapportage": "string",
        "idLivrableOrigine": "string",
        "referenceClientLivrableRapportage": "string",
        "libelleClientLivrableRapportage": "string",
        "typeModeleEditionLivrableRapportage": "string",
        "typeLivrableRapportage": {
            "code": "string",
            "libelle": "string"
        },
        "dateExpedition": "date",
        "desactivation": "boolean",
        "idUniqueApave": "string" //required
    },
    "donneesSi": {
        "idFoncSupport": "string",
        "idClientLivrableRapportage": "string",
        "idHeraclesRapport": "string",
        "idGedApave": "string",
        "versionGedApave": "string",
        "referenceExterne": "string"
    },
    "clientIntervention": {
        "idRelation": "string",
        "designationRelation": "string",
        "adresseReltion": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string"
        },
        "accompagnementClient": "boolean",
        "nomAccompagnateur": "string",
        "prenomAccompagnateur": "string",
        "referenceClient": "string"
    },
    "siteIntervention": {
        "idRelationSite": "string",
        "designationRelationSite": "string",
        "adresseRelationSite": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string",
            "etat": "string",
            "latitude": "number",
            "longitude": "number"
        },
        "referenceClientSite": "string"
    },
    "intervenants": [{
        "intervenant": {
            "codeCollaborateur": "string",
            "codeSociete": "string",
            "matricule": "string",
            "codeEntite": "string"
        },
        "nomIntervenant": "string",
        "prenomIntervenant": "string",
        "typeIntervenant": "string"
    }],
    "interventionLivrable": {
        "idTache": "string",
        "referenceExterneTache": "string",
        "datesIntervention": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "domaine": {
            "code": "string",
            "libelle": "string"
        },
        "typeVisite": "string",
        "nombreEcarts": "number",
        "essaiSireneIncendie": "boolean",
        "coupureElectrique": "boolean",
        "donneesEtendues": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idMission": "string",
        "idIntervention": "string",
        "numeroIntervention": "string",
        "typeMission": "string",
        "photo": {
            "idGedApave": {
                "idGedApave": "string"
              },
            "commentaire": "string"
        }
    },
    "perimetreTechniques": [{
        "maille": "string",
        "codeActif": "string",
        "designationActif": "string",
        "referenceClientActif": "string"
    }],
    "actifsAssocies": [{
        "typeActif": "string",
        "referenceClient": "string",
        "referenceApave": "string",
        "designation": "string",
        "identifiantConstructeur": "string",
        "parcEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "typeEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "familleEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "sousFamilleEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "localisation": {
            "code": "string",
            "libelle": "string"
        },
        "typeLocalisation": "string",
        "donneesEtendues": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idTechSansContact": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idClientTechSansContact": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "resultatsObservations": [{
            "code": "string",
            "libelle": "string",
            "numeroUnique": "string",
            "natureObservationSEL": "string",
            "typeObservationSEL": "string",
            "Observation": "string",
            "commentaires": "string",
            "recommendations": "string",
            "codePhrasier": "string",
            "referentielAppliqueNonConformite": "string",
            "donneesEtendues": [{
                "code": "string",
                "libelle": "string",
                "valeur": "string",
                "type": "string"
            }],
            "limitesIntervention": [],
            "numeroOrdre": "number",
            "typeDanger": "string",
            "refrenceClient": "string",
            "reccurent": "boolean",
            "anneeCreation": "number",
            "niveauDeGravite": "string",
            "niveauDeGraviteClient": "string",
            "pointDeControlAssocies": {
                "referenceClient": "string",
                "designation": "string",
                "niveau": [{
                    "code": "string",
                    "libelle": "string"
                }]
            },
            "photo": {
                "idGedApave": {
                    "idGedApave": "string"
                  },
                "commentaire": "string"
            }
        }],
        "donneesApogeeHisto": {
            "refExterneSite": "string",
            "idGmaoMainta": "number"
        },
        "photo": {
            "idGedApave": {
                "idGedApave": "string"
              },
            "commentaire": "string"
        }
    }],
    "tracesEnregistrements": [{
        "operation": "string", // ["C","M","D"]
        "date": "date",
        "utilisateur": "string"
    }],
    "destinatairesLivrables": [{
        "idContact": {
            "NumeroContact": "string",
            "numeroContactRDD": "string",
            "moyensCommunications": [{
                "type": "string",
                "valeur": "string"
            }]
        },
        "donneesContact": {
            "idContact": "string",
            "libelleRefCivilite": "string",
            "nom": "string",
            "prenom": "string"
        },
        "fonction": "string"
    }]
}' "{{BASE_URL}}/exposee/v1/caracteristiques"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-caracteristiques-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/caracteristiques HTTP/1.1
Host: 


{
    "idCompteSel": "idCompteSel", //required
    "donneesRapport": {
        "versionLivrableRapportage": "string",
        "libelleFichierLivrableRapportage": "string",
        "idLivrableOrigine": "string",
        "referenceClientLivrableRapportage": "string",
        "libelleClientLivrableRapportage": "string",
        "typeModeleEditionLivrableRapportage": "string",
        "typeLivrableRapportage": {
            "code": "string",
            "libelle": "string"
        },
        "dateExpedition": "date",
        "desactivation": "boolean",
        "idUniqueApave": "string" //required
    },
    "donneesSi": {
        "idFoncSupport": "string",
        "idClientLivrableRapportage": "string",
        "idHeraclesRapport": "string",
        "idGedApave": "string",
        "versionGedApave": "string",
        "referenceExterne": "string"
    },
    "clientIntervention": {
        "idRelation": "string",
        "designationRelation": "string",
        "adresseReltion": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string"
        },
        "accompagnementClient": "boolean",
        "nomAccompagnateur": "string",
        "prenomAccompagnateur": "string",
        "referenceClient": "string"
    },
    "siteIntervention": {
        "idRelationSite": "string",
        "designationRelationSite": "string",
        "adresseRelationSite": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string",
            "etat": "string",
            "latitude": "number",
            "longitude": "number"
        },
        "referenceClientSite": "string"
    },
    "intervenants": [{
        "intervenant": {
            "codeCollaborateur": "string",
            "codeSociete": "string",
            "matricule": "string",
            "codeEntite": "string"
        },
        "nomIntervenant": "string",
        "prenomIntervenant": "string",
        "typeIntervenant": "string"
    }],
    "interventionLivrable": {
        "idTache": "string",
        "referenceExterneTache": "string",
        "datesIntervention": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "domaine": {
            "code": "string",
            "libelle": "string"
        },
        "typeVisite": "string",
        "nombreEcarts": "number",
        "essaiSireneIncendie": "boolean",
        "coupureElectrique": "boolean",
        "donneesEtendues": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idMission": "string",
        "idIntervention": "string",
        "numeroIntervention": "string",
        "typeMission": "string",
        "photo": {
            "idGedApave": {
                "idGedApave": "string"
              },
            "commentaire": "string"
        }
    },
    "perimetreTechniques": [{
        "maille": "string",
        "codeActif": "string",
        "designationActif": "string",
        "referenceClientActif": "string"
    }],
    "actifsAssocies": [{
        "typeActif": "string",
        "referenceClient": "string",
        "referenceApave": "string",
        "designation": "string",
        "identifiantConstructeur": "string",
        "parcEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "typeEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "familleEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "sousFamilleEquipement": {
            "code": "string",
            "libelle": "string"
        },
        "localisation": {
            "code": "string",
            "libelle": "string"
        },
        "typeLocalisation": "string",
        "donneesEtendues": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idTechSansContact": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "idClientTechSansContact": [{
            "code": "string",
            "libelle": "string",
            "valeur": "string",
            "type": "string"
        }],
        "resultatsObservations": [{
            "code": "string",
            "libelle": "string",
            "numeroUnique": "string",
            "natureObservationSEL": "string",
            "typeObservationSEL": "string",
            "Observation": "string",
            "commentaires": "string",
            "recommendations": "string",
            "codePhrasier": "string",
            "referentielAppliqueNonConformite": "string",
            "donneesEtendues": [{
                "code": "string",
                "libelle": "string",
                "valeur": "string",
                "type": "string"
            }],
            "limitesIntervention": [],
            "numeroOrdre": "number",
            "typeDanger": "string",
            "refrenceClient": "string",
            "reccurent": "boolean",
            "anneeCreation": "number",
            "niveauDeGravite": "string",
            "niveauDeGraviteClient": "string",
            "pointDeControlAssocies": {
                "referenceClient": "string",
                "designation": "string",
                "niveau": [{
                    "code": "string",
                    "libelle": "string"
                }]
            },
            "photo": {
                "idGedApave": {
                    "idGedApave": "string"
                  },
                "commentaire": "string"
            }
        }],
        "donneesApogeeHisto": {
            "refExterneSite": "string",
            "idGmaoMainta": "number"
        },
        "photo": {
            "idGedApave": {
                "idGedApave": "string"
              },
            "commentaire": "string"
        }
    }],
    "tracesEnregistrements": [{
        "operation": "string", // ["C","M","D"]
        "date": "date",
        "utilisateur": "string"
    }],
    "destinatairesLivrables": [{
        "idContact": {
            "NumeroContact": "string",
            "numeroContactRDD": "string",
            "moyensCommunications": [{
                "type": "string",
                "valeur": "string"
            }]
        },
        "donneesContact": {
            "idContact": "string",
            "libelleRefCivilite": "string",
            "nom": "string",
            "prenom": "string"
        },
        "fonction": "string"
    }]
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-caracteristiques">
                            Delete Livrables Rapportage SEL
                            <a href="#request-delete-caracteristiques"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete data</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-delete-caracteristiques-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-caracteristiques-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-caracteristiques-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/caracteristiques/{{idCompteSel}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-caracteristiques-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/caracteristiques/{{idCompteSel}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-create-compteSel">
                            Create or Update CompteSel
                            <a href="#request-create-compteSel"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new CompteSel or update a CompteSel with same idCompteSel</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-compteSel-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-compteSel-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-compteSel-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "idCompteSel": "idCompteSel", //required
    "accesUtilisateurAutorise": false,
    "libelle": "string",
    "dateDebut": "date",
	"dateFin": "date",
	"typologieDuClient": "string",
	"niveauDeService": {
		"code": "string",
		"libelle": "string",
		"service": {
			"code": "string",
			"libelle": "string"
		}
	},
	"fonctionnalites": [{
		"code": "string",
		"libelle": "string",
		"parametresFonctionalites": [{
			"code": "string",
			"format": "string",
			"valeur": "string",
			"libelleValeur": "string"
		}]
	}],
	"perimetreSourceCompte": {
		"donneesEnProvenance": [] // text array
	},
	"tracesEnregistrements": [{
		"operation": "string", //"enum": ["C", "M", "D"]
		"date": "date",
		"utilisateur": "string"
	}],
	"pilotage": {
		"codeEntitePilote": "string",
		"situationContractuelleCompte": [{
			"type": "string",
			"dateDebut": "date",
			"dateFin": "date"
		}]
	},
	"relationCompte": {
		"raisonSociale": "string",
        "numeroIdentificationLocal": "string",
        "DUNSEtablissement": "string",
        "DUNSParentCompany": "string",
        "DUNSUltimateParentCompany": "string",
		"SIREN": "string",
		"SIRET": "string",
		"adresse": {
			"adresse4": "string",
            "adresse5": "string",
			"codePostal": "string",
			"libelleCommune": "string",
			"libellePays": "string",
            "codePays": "string",
            "etat": "string",
            "latitude": "number",
            "longitude": "number"
		}
	},
    "destinataireLivrable": {
        "libelleRefCivilite": "string",
        "nom": "string",
        "prenom": "string",
        "email": "string",
        "fonction": "string"
    }
}' "{{BASE_URL}}/exposee/v1/compteSel"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-compteSel-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/compteSel HTTP/1.1
Host: 


{
    "idCompteSel": "idCompteSel", //required
    "accesUtilisateurAutorise": false,
    "libelle": "string",
    "dateDebut": "date",
	"dateFin": "date",
	"typologieDuClient": "string",
	"niveauDeService": {
		"code": "string",
		"libelle": "string",
		"service": {
			"code": "string",
			"libelle": "string"
		}
	},
	"fonctionnalites": [{
		"code": "string",
		"libelle": "string",
		"parametresFonctionalites": [{
			"code": "string",
			"format": "string",
			"valeur": "string",
			"libelleValeur": "string"
		}]
	}],
	"perimetreSourceCompte": {
		"donneesEnProvenance": [] // text array
	},
	"tracesEnregistrements": [{
		"operation": "string", //"enum": ["C", "M", "D"]
		"date": "date",
		"utilisateur": "string"
	}],
	"pilotage": {
		"codeEntitePilote": "string",
		"situationContractuelleCompte": [{
			"type": "string",
			"dateDebut": "date",
			"dateFin": "date"
		}]
	},
	"relationCompte": {
		"raisonSociale": "string",
        "numeroIdentificationLocal": "string",
        "DUNSEtablissement": "string",
        "DUNSParentCompany": "string",
        "DUNSUltimateParentCompany": "string",
		"SIREN": "string",
		"SIRET": "string",
		"adresse": {
			"adresse4": "string",
            "adresse5": "string",
			"codePostal": "string",
			"libelleCommune": "string",
			"libellePays": "string",
            "codePays": "string",
            "etat": "string",
            "latitude": "number",
            "longitude": "number"
		}
	},
    "destinataireLivrable": {
        "libelleRefCivilite": "string",
        "nom": "string",
        "prenom": "string",
        "email": "string",
        "fonction": "string"
    }
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-compteSel">
                            Delete CompteSel
                            <a href="#request-delete-compteSel"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete CompteSel</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-compteSel-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-compteSel-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-compteSel-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/compteSel/{{idCompteSel}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-compteSel-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/compteSel/{{idCompteSel}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-create-equipements">
                            Create or Update Equipement
                            <a href="#request-create-equipements"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new Equipement or update a Equipement with same referenceApave</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-create-equipements-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-equipements-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-equipements-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
    {
        "descriptifTechnique": {
            "referenceApave": "string",
            "referenceApaveSas": "string",
            "referenceClient": "string",
            "mobilite": "boolean",
            "equipementsAssocies": [],
            "referentiel": "string",
            "regimeFabrication": "string",
            "designation": "string",
            "typeEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "famille": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "parcEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "domaineEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "caracteristiquesSpecifiques": [{
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            }],
            "lotAccessoires": "boolean",
            "sousEquipements": []
            "quantiteTotalAccessoires": "string"
        },
        "situation": {
            "codeRefEquipementEtat": "string",
            "dateEtat": "date"
        },
        "proprietaire": {
            "idRelation": "string"
            "idCompteSel": "string",
            "siretRelation": "string",
            "adresseRelation": {
                "type": "string",
                "adresse2": "string",
                "adresse3": "string",
                "adresse4": "string",
                "adresse5": "string",
                "codePostal": "string",
                "localiteDestination": "string",
                "codePays": "string",
                "libellePays": "string",
                "codeCommune": "string",
                "libelleCommune": "string",
                "referenceExterneAdresse": "string",
                "longitude": "string",
                "latitude": "string",
                "codeCedex": "string"
            },
            "siOrigineRelation": "string"
        },
        "localisation": {
            "repereEquipement": {
                "repere1": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                },
                "repere2": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                },
                "repere3": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                }
            }
        },
        "constructeur": {
            "identifiantConstructeur": "string",
            "nomConstructeur": "string",
            "anneeConstruction": "string",
        },
        "donneesReglementaires": {
            "verificationsEquipement": [{
                "codeTypeVerification": "string",
                "libTypeVerification": "string",
                "libPeriodicite": "string",
                "periodicite": "string",
                "numeroTache": "string",
                "dateProchaineVisite": "date",
                "dateVisite": "date"
            }]
        },
        "desactivation": {
            "dateDesactivation": "date",
            "inactif": "boolean"
        },
        "tracesEnregistrements": [{
            "operation": "string" //"enum": ["C","M","D"]
            "date": "date",
            "utilisateur": "string",
        }]
    }' "{{BASE_URL}}/exposee/v1/equipements"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-equipements-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/equipements HTTP/1.1
    Host: 
    
    
    {
        "descriptifTechnique": {
            "referenceApave": "string",
            "referenceApaveSas": "string",
            "referenceClient": "string",
            "mobilite": "boolean",
            "equipementsAssocies": [],
            "referentiel": "string",
            "regimeFabrication": "string",
            "designation": "string",
            "typeEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "famille": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "parcEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "domaineEquipement": {
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            },
            "caracteristiquesSpecifiques": [{
                "codeDonneeReference": "string",
                "libelleDonneeReference": "string",
                "valeurDonneeReference": "string",
                "type": "string"
            }],
            "lotAccessoires": "boolean",
            "sousEquipements": []
            "quantiteTotalAccessoires": "string"
        },
        "situation": {
            "codeRefEquipementEtat": "string",
            "dateEtat": "date"
        },
        "proprietaire": {
            "idRelation": "string"
            "idCompteSel": "string",
            "siretRelation": "string",
            "adresseRelation": {
                "type": "string",
                "adresse2": "string",
                "adresse3": "string",
                "adresse4": "string",
                "adresse5": "string",
                "codePostal": "string",
                "localiteDestination": "string",
                "codePays": "string",
                "libellePays": "string",
                "codeCommune": "string",
                "libelleCommune": "string",
                "referenceExterneAdresse": "string",
                "longitude": "string",
                "latitude": "string",
                "codeCedex": "string"
            },
            "siOrigineRelation": "string"
        },
        "localisation": {
            "repereEquipement": {
                "repere1": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                },
                "repere2": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                },
                "repere3": {
                    "codeDonneeReference": "string",
                    "libelleDonneeReference": "string",
                    "valeurDonneeReference": "string",
                    "type": "string",
                }
            }
        },
        "constructeur": {
            "identifiantConstructeur": "string",
            "nomConstructeur": "string",
            "anneeConstruction": "string",
        },
        "donneesReglementaires": {
            "verificationsEquipement": [{
                "codeTypeVerification": "string",
                "libTypeVerification": "string",
                "libPeriodicite": "string",
                "periodicite": "string",
                "numeroTache": "string",
                "dateProchaineVisite": "date",
                "dateVisite": "date"
            }]
        },
        "desactivation": {
            "dateDesactivation": "date",
            "inactif": "boolean"
        },
        "tracesEnregistrements": [{
            "operation": "string" //"enum": ["C","M","D"]
            "date": "date",
            "utilisateur": "string",
        }]
    }</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-equipements">
                            Delete Equipement
                            <a href="#request-delete-equipements"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete Equipement</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-delete-equipements-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-equipements-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-equipements-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/equipements/{{referenceApave}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-equipements-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/equipements/{{referenceApave}} HTTP/1.1
    Host: </code></pre>
                                </div>
                            </div>
                        </div>

                        <hr>
                    </div>


                    <div class="request">

                        <h3 id="request-create-interventionSel">
                            Create or Update InterventionSel
                            <a href="#request-create-interventionSel"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new InterventionSel or update a InterventionSel with same idCompteSel</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-create-interventionSel-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-interventionSel-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-interventionSel-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "idCompteSel": "idCompteSel", //required
    "interventionSEL": {
        "idIntervention": "string",
        "numeroIntervention": "string",
        "idsTaches": [],
        "referenceExterneTache": "string",
        "designationIntervention": "string",
        "etatAvancementIntervention": "string",
        "datesPrevues": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "datesReelles": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "dateProchaineVisite": "date",
        "intervenant": {
            "codeCollaborateur": "string",
            "nom": "string",
            "prenom": "string"
        },
        "anneeExercice ": "number",
        "numeroAccord": "string",
        "referenceCommandeClient": "string"
    },
    "donnesProduitSel": {
        "produit": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        },
        "champ": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        },
        "domaineTechnique": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        }
    },
    "organisation": {
        "codeEntite": "string",
        "codeAgence": "string",
        "libelleAgence": "string",
        "telephoneAgence": "string"
    },
    "relationIntervention": [{
        "role": "string",
        "refClient": "string",
        "idRelation": "string",
        "adresseRelation": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string",
            "referenceExterneAdresse": "string",
            "longitude": "string",
            "latitude": "string",
            "codeCedex": "string"
        },
        "donneesRelation": {
            "raisonSociale": "string",
            "designation": "string",
            "typeRelation": "string", //"enum": ["SGSOC","ETSEC","SUBOR","PSEUDO"],
            "codeIntraGroupe": "string",
            "relationParent": "string",
            "referenceExterne": "string",
            "sigle": "string",
            "enseigne": "string",
            "codeAssociation": "string",
            "codeSiren": "string",
            "codeNic": "string",
            "numeroTvaIntracommunautaire": "string",
            "numeroDuns": "string",
            "codeFormeJuridique": "string",
            "codeNaf": "string",
            "codeTrancheEffectif": "string"
        }
    }],
    "tracesEnregistrements": [{
        "operation": "string", //"enum": ["C","M","D"]
        "date": "date",
        "utilisateur": "string"
    }],
    "destinataireLivrable": {
        "libelleRefCivilite": "string",
        "nom": "string",
        "prenom": "string",
        "email": "string"
    }
}' "{{BASE_URL}}/exposee/v1/interventionSel"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-interventionSel-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/interventionSel HTTP/1.1
Host: 


{
    "idCompteSel": "idCompteSel", //required
    "interventionSEL": {
        "idIntervention": "string",
        "numeroIntervention": "string",
        "idsTaches": [],
        "referenceExterneTache": "string",
        "designationIntervention": "string",
        "etatAvancementIntervention": "string",
        "datesPrevues": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "datesReelles": {
            "dateDebut": "date",
            "dateFin": "date"
        },
        "dateProchaineVisite": "date",
        "intervenant": {
            "codeCollaborateur": "string",
            "nom": "string",
            "prenom": "string"
        },
        "anneeExercice ": "number",
        "numeroAccord": "string",
        "referenceCommandeClient": "string"
    },
    "donnesProduitSel": {
        "produit": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        },
        "champ": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        },
        "domaineTechnique": {
            "codeDonneeReference": "string",
            "libelleDonneeReference": "string"
        }
    },
    "organisation": {
        "codeEntite": "string",
        "codeAgence": "string",
        "libelleAgence": "string",
        "telephoneAgence": "string"
    },
    "relationIntervention": [{
        "role": "string",
        "refClient": "string",
        "idRelation": "string",
        "adresseRelation": {
            "type": "string",
            "adresse2": "string",
            "adresse3": "string",
            "adresse4": "string",
            "adresse5": "string",
            "codePostal": "string",
            "localiteDestination": "string",
            "codePays": "string",
            "libellePays": "string",
            "codeCommune": "string",
            "libelleCommune": "string",
            "referenceExterneAdresse": "string",
            "longitude": "string",
            "latitude": "string",
            "codeCedex": "string"
        },
        "donneesRelation": {
            "raisonSociale": "string",
            "designation": "string",
            "typeRelation": "string", //"enum": ["SGSOC","ETSEC","SUBOR","PSEUDO"],
            "codeIntraGroupe": "string",
            "relationParent": "string",
            "referenceExterne": "string",
            "sigle": "string",
            "enseigne": "string",
            "codeAssociation": "string",
            "codeSiren": "string",
            "codeNic": "string",
            "numeroTvaIntracommunautaire": "string",
            "numeroDuns": "string",
            "codeFormeJuridique": "string",
            "codeNaf": "string",
            "codeTrancheEffectif": "string"
        }
    }],
    "tracesEnregistrements": [{
        "operation": "string", //"enum": ["C","M","D"]
        "date": "date",
        "utilisateur": "string"
    }],
    "destinataireLivrable": {
        "libelleRefCivilite": "string",
        "nom": "string",
        "prenom": "string",
        "email": "string"
    }
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-interventionSel">
                            Delete InterventionSel
                            <a href="#request-delete-interventionSel"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete InterventionSel</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a
                                        href="#request-delete-interventionSel-example-curl" data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-interventionSel-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-interventionSel-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/interventionSel/{{idCompteSel}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-interventionSel-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/interventionSel/{{idCompteSel}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-create-offre">
                            Create or Update Offre
                            <a href="#request-create-offre"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new Offre or update a Offre with same idOffre</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-offre-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-offre-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-offre-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "idOffre": "string", //requried
    "idCompteSEL": "string",
    "numeroOffre": "string",
    "version": "number",
    "libelleOffre": "string",
    "societeContractante": {
        "codeSociete": "string"
    },
    "libelleSocieteContractante": "string",
    "agenceGestionOffre": {
        "codeAgence": "string"
    },
    "libelleAgenceGestionOffre": "string",
    "siteGeographique": {
        "codeSiteGeographique": "string"
    },
    "libelleSiteGeographique": "string",
    "agenceGestionContrat": {
        "codeAgence": "string"
    },
    "libelleAgenceGestionContrat": "string",
    "relationSignataire": {
        "idRelation": "string"
    },
    "raisonSociale": "string",
    "adresse": {
        "type": "string", //["ETR", "SFR", "CFR"] => ETRANGER, STD FRANCE , CEDEX France
        "adresse2": "string",
        "adresse3": "string",
        "adresse4": "string",
        "adresse5": "string",
        "codePostal": "string",
        "localiteDestination": "string",
        "codePays": "string",
        "libellePays": "string",
        "codeCommune": "string",
        "libelleCommune": "string",
        "referenceExterneAdresse": "string",
        "longitude": "number",
        "latitude": "number",
        "codeCedex": "number",
        "etat": "string"
    },
    "SIRET": "string",
    "codeRefOffreType": "string",
    "libelleRefOffreType": "string",
    "codeRefOffreTypeAvenant": "string",
    "libelleRefOffreTypeAvenant": "string",
    "commentaireAvenant": "string",
    "contratRecurrent": "boolean",
    "codeRefContratNature": "string",
    "libelleRefContratNature": "string",
    "codeRefOffreStatut": "string",
    "libelleRefOffreStatut": "string",
    "dateStatut": "date",
    "dateFinValidite": "date",
    "codeRefOffreOrigine": "string",
    "libelleRefOffreOrigine": "string",
    "numeroSuiviRelationCommerciale": "string",
    "dateDemandeClient": "date",
    "dateOffre": "date",
    "accord": {
        "idAccord": "string",
        "libelle": "string"
    },
    "dateEffet": "date",
    "dateFinEffetContrat": "date",
    "codeRefTypeRevisionPrix": "string",
    "libelleRefTypeRevisionPrix": "string",
    "montantHT": "number",
    "codeRefDevise": "string",
    "libelleRefDevise": "string",
    "dossierFacturationUnique": "boolean",
    "contratOrigine": {
        "idContrat": "string"
    },
    "codeRefOffreMotifSansExpedition": "string",
    "libelleRefOffreMotifSansExpedition": "string",
    "codeRefProduitOffreTrame": "string",
    "libelleRefProduitOffreTrame": "string",
    "documentOffre": {
        "idGedApave": "string",
        "classeDocumentaire": "string",
        "libelleRefClasseDocumentaire": "string",
        "codeRefDocumentNature": "string",
        "libelleRefDocumentNature": "string",
        "dateDuDocument": "date",
        "libelle": "string",
        "referenceApave": "string",
        "version": "string"
    },
    "documentsAnnexes": [
        {
            "idGedApave": "string",
            "classeDocumentaire": "string",
            "libelleRefClasseDocumentaire": "string",
            "codeRefDocumentNature": "string",
            "libelleRefDocumentNature": "string",
            "dateDuDocument": "date",
            "libelle": "string",
            "referenceApave": "string",
            "version": "string"
        }
    ],
    "missions": [
        {
            "uniteGestion": {
                "codeUniteAgence": "string",
                "libelleUniteAgence": "string"
            },
            "numeroMissionOffre": "number",
            "dateEffet": "date",
            "libelle": "string",
            "relationRoles": [
                {
                    "relation": {
                        "idRelation": "string"
                    },
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", //["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string",
                    "codeRefRelationRole": "string",
                    "moyensContacts": [
                        {
                            "contact": {
                                "idContact": "string"
                            },
                            "selectionMoyensCommunications": {
                                "moyenCommunicationParDefaut": "boolean",
                                "communiquerParMail": "boolean",
                                "typeDestinataire": "string",
                                "libelleTypeDestinataire": "string",
                                "communiquerParTelephone": "boolean",
                                "communiquerParFax": "boolean",
                                "communiquerParCourrier": "boolean"
                            },
                            "nom": "string",
                            "prenom": "string",
                            "fonction": "string"
                        }
                    ],
                    "selectionMoyensCommunications": {
                        "moyenCommunicationParDefaut": "boolean",
                        "communiquerParMail": "boolean",
                        "typeDestinataire": "string",
                        "libelleTypeDestinataire": "string",
                        "communiquerParTelephone": "boolean",
                        "communiquerParFax": "boolean",
                        "communiquerParCourrier": "boolean"
                    }
                }
            ],
            "acteurs": [{
                "pourcentage": "number",
                "montantHT": "number",
                "codeCollaborateur": "string",
                "codeRefCollaborateurRole": "string"
            }],
            "selectionProduit": {
                "produit": {
                    "idProduit": "string"
                },
                "codeProduit": "string",
                "libelleClient": "string",
                "modules": {
                    "description": "Modules du produit que doit réaliser la mission.",
                    "type": "array",
                    "items": {
                        "idModuleMetier": "string",
                        "codeModule": "string",
                        "libelleModule": "string"
                    }
                }
            },
            "ligneTarifs": [{
                "idLigneTarifAccord": "string",
                "codeArticle": "string",
                "libelleLigneTarif": "string",
                "numeroOrdre": "number",
                "codeArticleClient": "string",
                "quantite": "number",
                "prixUnitaire": "number",
                "codeRefArticleUnite": "string",
                "libelleRefArticleUnite": "string",
                "montantAvantRemiseHT": "number",
                "tauxRemise": "number",
                "montantHT": "number",
                "codeRefTauxTva": "string",
                "libelleRefTauxTva": "string",
                "montantTva": "number",
                "codeRefPeriodiciteIntervention": "string",
                "libelleRefPeriodiciteIntervention": "string"
            }],
            "produitPlusValueFacturation": [{
                "codeRefProduitPlusValueFacturation": "string",
                "libelleRefProduitPlusValueFacturation": "string"
            }],
            "detailChiffrage": {
                "montantHtMinimumIntervention": "number",
                "decompositionPrix": "string",
                "codeRefMissionModeChiffrage": "string",
                "nombreJoursAlloue": "number",
                "montantHT": "number",
                "pourcentageRemise": "number",
                "montantRemise": "number",
                "montantTotal": "number",
                "prixVenteSaisi": "number",
                "montantFactureRelationSaisi": "number",
                "montantSousTraitancePrevueLibelle": "string",
                "montantSousTraitancePrevue": "number",
                "montantVisiteInitiale": "number",
                "coeffVisiteInitiale": "number",
                "codeRefPeriodiciteIntervention": "string",
                "libelleRefPeriodiciteIntervention": "string"
            },
            "detailTempsVisites": [{
                "numeroVisite": "number",
                "tempsVisite": "number"
            }],
            "caracteristiquesIntervention": {
                "echeanceESP": "boolean",
                "nombreSemaineExpeditionAvis": "number",
                "limitesInterventions": "string",
                "joursInterdits": "string",
                "infoPlanificationTemporaire": "string",
                "infoPlanificationPermanente": "string",
                "dateDebutAuPlusTot": "date",
                "dateFinAuPlusTard": "date",
                "date1ereTacheImposee": "date",
                "heure1ereTacheImposee": "number",
                "minute1ereTacheImposee": "number",
                "numeroAssociation": "string"
            },
            "caracteristiquesLivrable": {
                "prixCache": "boolean"
            },
            "specificiteProduitBatiment": {
                "pourcentageHonoraireTravaux": "number",
                "montantTravaux": "number",
                "estMontantTTC": "boolean",
                "montantMoisSupplementaire": "number",
                "dateDebutTravaux": "date",
                "dateDebut": "date",
                "dureeMission": "number",
                "dureeTravaux": "number",
                "libelleChantier": "string",
                "dureePhaseConception": "number",
                "estCISSCT": "boolean",
                "nombreLots": "number",
                "pourcentageMontantTravaux": "number",
                "nombreEntrepriseTravaux": "number",
                "codeRefMissionTypePhaseSPS": "string",
                "libelleRefMissionTypePhaseSPS": "string",
                "codeRefMissionCategorieOperationSPS": "string",
                "libelleRefMissionCategorieOperationSPS": "string"
            },
            "organismesPayeurs": [{
                "relationPayeur": {
                    "idRelation": "string",
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", // ["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string"
                },
                "pourcentage": "number",
                "montant": "number",
                "relationDestinataireFacture": {
                    "idRelation": "string",
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", // ["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string"
                }
            }],
            "session": {
                "session": {
                    "idSession": "number"
                },
                "nbStagiaire": "number",
                "demandeReservation": "boolean",
                "commentaire": "string",
                "codeRefSessionModeRealisation": "string",
                "libelleRefSessionModeRealisation": "string",
                "estHorsFormation": "boolean",
                "agencePilote": {
                    "codeAgence": "string"
                },
                "libelleAgencePilote": "string",
                "sessionModules": [
                    {
                        "tache": {
                            "idTache": "string"
                        },
                        "moduleProduit": {
                            "idModuleMetier": "string",
                            "codeModule": "string",
                            "libelleModule": "string"
                        },
                        "dureeJours": "number",
                        "raisonSociale": "string",
                        "adresse": {
                            "type": "string", // ["ETR", "SFR", "CFR"]
                            "adresse2": "string",
                            "adresse3": "string",
                            "adresse4": "string",
                            "adresse5": "string",
                            "codePostal": "string",
                            "localiteDestination": "string",
                            "codePays": "string",
                            "libellePays": "string",
                            "codeCommune": "string",
                            "libelleCommune": "string",
                            "referenceExterneAdresse": "string",
                            "longitude": "number",
                            "latitude": "number",
                            "codeCedex": "number",
                            "etat": "string"
                        },
                        "dateDebut": "date"
                        "dateFin": "date"
                        "formateur": {
                            "codeCollaborateur": "string"
                        },
                        "nomFormateur": "string",
                        "prenomFormateur": "string",
                        "nombrePlacesDemande": "number",
                        "codeRefSessionModeRealisation": "string",
                        "libelleRefSessionModeRealisation": "string",
                        "stagiairesIdentifies": [
                            {
                                "stagiaire": {
                                    "idStagiaire": "number"
                                },
                                "produitStageCertificatCategories": [{
                                    "codeRefProduitStageCertificatCategories": "string",
                                    "libelleRefProduitStageCertificatCategories": "string"
                                }],
                                "nom": "string",
                                "prenom": "string",
                                "dateDeNaissance": "date"
                            }
                        ]
                    }
                ]
            },
            "caracteristiquesFacturation": {
                "codeRefModeFacturation": "string",
                "libelleRefModeFacturation": "string",
                "eligibleFacturationAuto": "boolean",
                "codeRefTauxTva": "string",
                "libelleRefTauxTva": "string",
                "codeRefDelaiPaiement": "string",
                "libelleRefDelaiPaiement": "string",
                "codeRefModePaiement": "string",
                "libelleRefModePaiement": "string",
                "numeroFranchiseTVA": "string",
                "tauxAcompte": "number"
            }
        }
    ],
    "acteurs": [{
        "pourcentage": "number",
        "montantHT": "number",
        "codeCollaborateur": "string",
        "codeRefCollaborateurRole": "string"
    }],
    "reponse": {
        "dateReponseClient": "date",
        "dateSignature": "date",
        "numeroBonCommande": "string",
        "codeRefOffreMotifRefus": "string",
        "codeRefConcurrent": "string",
        "montantConcurrence": "number"
    },
    "relationRoles": [
        {
            "relation": {
                "idRelation": "string"
            },
            "raisonSociale": "string",
            "adresse": {
                "type": "string", // ["ETR", "SFR", "CFR"]
                "adresse2": "string",
                "adresse3": "string",
                "adresse4": "string",
                "adresse5": "string",
                "codePostal": "string",
                "localiteDestination": "string",
                "codePays": "string",
                "libellePays": "string",
                "codeCommune": "string",
                "libelleCommune": "string",
                "referenceExterneAdresse": "string",
                "longitude": "number",
                "latitude": "number",
                "codeCedex": "number",
                "etat": "string"
            },
            "SIRET": "string",
            "codeRefRelationRole": "string",
            "moyensContacts": [{
                "contact": {
                    "idContact": "string"
                },
                "selectionMoyensCommunications": {
                    "moyenCommunicationParDefaut": "boolean",
                    "communiquerParMail": "boolean",
                    "typeDestinataire": "string",
                    "libelleTypeDestinataire": "string",
                    "communiquerParTelephone": "boolean",
                    "communiquerParFax": "boolean",
                    "communiquerParCourrier": "boolean"
                },
                "nom": {
                    "description": "Nom du contact",
                    "type": "string",
                    "maxLength": 50
                },
                "prenom": {
                    "description": "Prénom du contact",
                    "type": "string",
                    "maxLength": 50
                },
                "fonction": {
                    "description": "Fonction exacte dans l'entreprise",
                    "type": "string",
                    "maxLength": 50
                },
                "email": {
                    "description": "Mail du signataire de l'offre",
                    "type": "string",
                    "maxLength": 255
                }
            }],
            "selectionMoyensCommunications": {
                "moyenCommunicationParDefaut": "boolean",
                "communiquerParMail": "boolean",
                "typeDestinataire": "string",
                "libelleTypeDestinataire": "string",
                "communiquerParTelephone": "boolean",
                "communiquerParFax": "boolean",
                "communiquerParCourrier": "boolean"
            }
        }
    ],
    "tracesEnregistrements": [{
        "operation": "string", // ["C", "M", "D"]
        "date": "date",
        "utilisateur": "string"
    }]
}' "{{BASE_URL}}/exposee/v1/offre"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-offre-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/exposee/v1/offre HTTP/1.1
Host: 


{
    "idOffre": "string", //requried
    "idCompteSEL": "string",
    "numeroOffre": "string",
    "version": "number",
    "libelleOffre": "string",
    "societeContractante": {
        "codeSociete": "string"
    },
    "libelleSocieteContractante": "string",
    "agenceGestionOffre": {
        "codeAgence": "string"
    },
    "libelleAgenceGestionOffre": "string",
    "siteGeographique": {
        "codeSiteGeographique": "string"
    },
    "libelleSiteGeographique": "string",
    "agenceGestionContrat": {
        "codeAgence": "string"
    },
    "libelleAgenceGestionContrat": "string",
    "relationSignataire": {
        "idRelation": "string"
    },
    "raisonSociale": "string",
    "adresse": {
        "type": "string", //["ETR", "SFR", "CFR"] => ETRANGER, STD FRANCE , CEDEX France
        "adresse2": "string",
        "adresse3": "string",
        "adresse4": "string",
        "adresse5": "string",
        "codePostal": "string",
        "localiteDestination": "string",
        "codePays": "string",
        "libellePays": "string",
        "codeCommune": "string",
        "libelleCommune": "string",
        "referenceExterneAdresse": "string",
        "longitude": "number",
        "latitude": "number",
        "codeCedex": "number",
        "etat": "string"
    },
    "SIRET": "string",
    "codeRefOffreType": "string",
    "libelleRefOffreType": "string",
    "codeRefOffreTypeAvenant": "string",
    "libelleRefOffreTypeAvenant": "string",
    "commentaireAvenant": "string",
    "contratRecurrent": "boolean",
    "codeRefContratNature": "string",
    "libelleRefContratNature": "string",
    "codeRefOffreStatut": "string",
    "libelleRefOffreStatut": "string",
    "dateStatut": "date",
    "dateFinValidite": "date",
    "codeRefOffreOrigine": "string",
    "libelleRefOffreOrigine": "string",
    "numeroSuiviRelationCommerciale": "string",
    "dateDemandeClient": "date",
    "dateOffre": "date",
    "accord": {
        "idAccord": "string",
        "libelle": "string"
    },
    "dateEffet": "date",
    "dateFinEffetContrat": "date",
    "codeRefTypeRevisionPrix": "string",
    "libelleRefTypeRevisionPrix": "string",
    "montantHT": "number",
    "codeRefDevise": "string",
    "libelleRefDevise": "string",
    "dossierFacturationUnique": "boolean",
    "contratOrigine": {
        "idContrat": "string"
    },
    "codeRefOffreMotifSansExpedition": "string",
    "libelleRefOffreMotifSansExpedition": "string",
    "codeRefProduitOffreTrame": "string",
    "libelleRefProduitOffreTrame": "string",
    "documentOffre": {
        "idGedApave": "string",
        "classeDocumentaire": "string",
        "libelleRefClasseDocumentaire": "string",
        "codeRefDocumentNature": "string",
        "libelleRefDocumentNature": "string",
        "dateDuDocument": "date",
        "libelle": "string",
        "referenceApave": "string",
        "version": "string"
    },
    "documentsAnnexes": [
        {
            "idGedApave": "string",
            "classeDocumentaire": "string",
            "libelleRefClasseDocumentaire": "string",
            "codeRefDocumentNature": "string",
            "libelleRefDocumentNature": "string",
            "dateDuDocument": "date",
            "libelle": "string",
            "referenceApave": "string",
            "version": "string"
        }
    ],
    "missions": [
        {
            "uniteGestion": {
                "codeUniteAgence": "string",
                "libelleUniteAgence": "string"
            },
            "numeroMissionOffre": "number",
            "dateEffet": "date",
            "libelle": "string",
            "relationRoles": [
                {
                    "relation": {
                        "idRelation": "string"
                    },
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", //["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string",
                    "codeRefRelationRole": "string",
                    "moyensContacts": [
                        {
                            "contact": {
                                "idContact": "string"
                            },
                            "selectionMoyensCommunications": {
                                "moyenCommunicationParDefaut": "boolean",
                                "communiquerParMail": "boolean",
                                "typeDestinataire": "string",
                                "libelleTypeDestinataire": "string",
                                "communiquerParTelephone": "boolean",
                                "communiquerParFax": "boolean",
                                "communiquerParCourrier": "boolean"
                            },
                            "nom": "string",
                            "prenom": "string",
                            "fonction": "string"
                        }
                    ],
                    "selectionMoyensCommunications": {
                        "moyenCommunicationParDefaut": "boolean",
                        "communiquerParMail": "boolean",
                        "typeDestinataire": "string",
                        "libelleTypeDestinataire": "string",
                        "communiquerParTelephone": "boolean",
                        "communiquerParFax": "boolean",
                        "communiquerParCourrier": "boolean"
                    }
                }
            ],
            "acteurs": [{
                "pourcentage": "number",
                "montantHT": "number",
                "codeCollaborateur": "string",
                "codeRefCollaborateurRole": "string"
            }],
            "selectionProduit": {
                "produit": {
                    "idProduit": "string"
                },
                "codeProduit": "string",
                "libelleClient": "string",
                "modules": {
                    "description": "Modules du produit que doit réaliser la mission.",
                    "type": "array",
                    "items": {
                        "idModuleMetier": "string",
                        "codeModule": "string",
                        "libelleModule": "string"
                    }
                }
            },
            "ligneTarifs": [{
                "idLigneTarifAccord": "string",
                "codeArticle": "string",
                "libelleLigneTarif": "string",
                "numeroOrdre": "number",
                "codeArticleClient": "string",
                "quantite": "number",
                "prixUnitaire": "number",
                "codeRefArticleUnite": "string",
                "libelleRefArticleUnite": "string",
                "montantAvantRemiseHT": "number",
                "tauxRemise": "number",
                "montantHT": "number",
                "codeRefTauxTva": "string",
                "libelleRefTauxTva": "string",
                "montantTva": "number",
                "codeRefPeriodiciteIntervention": "string",
                "libelleRefPeriodiciteIntervention": "string"
            }],
            "produitPlusValueFacturation": [{
                "codeRefProduitPlusValueFacturation": "string",
                "libelleRefProduitPlusValueFacturation": "string"
            }],
            "detailChiffrage": {
                "montantHtMinimumIntervention": "number",
                "decompositionPrix": "string",
                "codeRefMissionModeChiffrage": "string",
                "nombreJoursAlloue": "number",
                "montantHT": "number",
                "pourcentageRemise": "number",
                "montantRemise": "number",
                "montantTotal": "number",
                "prixVenteSaisi": "number",
                "montantFactureRelationSaisi": "number",
                "montantSousTraitancePrevueLibelle": "string",
                "montantSousTraitancePrevue": "number",
                "montantVisiteInitiale": "number",
                "coeffVisiteInitiale": "number",
                "codeRefPeriodiciteIntervention": "string",
                "libelleRefPeriodiciteIntervention": "string"
            },
            "detailTempsVisites": [{
                "numeroVisite": "number",
                "tempsVisite": "number"
            }],
            "caracteristiquesIntervention": {
                "echeanceESP": "boolean",
                "nombreSemaineExpeditionAvis": "number",
                "limitesInterventions": "string",
                "joursInterdits": "string",
                "infoPlanificationTemporaire": "string",
                "infoPlanificationPermanente": "string",
                "dateDebutAuPlusTot": "date",
                "dateFinAuPlusTard": "date",
                "date1ereTacheImposee": "date",
                "heure1ereTacheImposee": "number",
                "minute1ereTacheImposee": "number",
                "numeroAssociation": "string"
            },
            "caracteristiquesLivrable": {
                "prixCache": "boolean"
            },
            "specificiteProduitBatiment": {
                "pourcentageHonoraireTravaux": "number",
                "montantTravaux": "number",
                "estMontantTTC": "boolean",
                "montantMoisSupplementaire": "number",
                "dateDebutTravaux": "date",
                "dateDebut": "date",
                "dureeMission": "number",
                "dureeTravaux": "number",
                "libelleChantier": "string",
                "dureePhaseConception": "number",
                "estCISSCT": "boolean",
                "nombreLots": "number",
                "pourcentageMontantTravaux": "number",
                "nombreEntrepriseTravaux": "number",
                "codeRefMissionTypePhaseSPS": "string",
                "libelleRefMissionTypePhaseSPS": "string",
                "codeRefMissionCategorieOperationSPS": "string",
                "libelleRefMissionCategorieOperationSPS": "string"
            },
            "organismesPayeurs": [{
                "relationPayeur": {
                    "idRelation": "string",
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", // ["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string"
                },
                "pourcentage": "number",
                "montant": "number",
                "relationDestinataireFacture": {
                    "idRelation": "string",
                    "raisonSociale": "string",
                    "adresse": {
                        "type": "string", // ["ETR", "SFR", "CFR"]
                        "adresse2": "string",
                        "adresse3": "string",
                        "adresse4": "string",
                        "adresse5": "string",
                        "codePostal": "string",
                        "localiteDestination": "string",
                        "codePays": "string",
                        "libellePays": "string",
                        "codeCommune": "string",
                        "libelleCommune": "string",
                        "referenceExterneAdresse": "string",
                        "longitude": "number",
                        "latitude": "number",
                        "codeCedex": "number",
                        "etat": "string"
                    },
                    "SIRET": "string"
                }
            }],
            "session": {
                "session": {
                    "idSession": "number"
                },
                "nbStagiaire": "number",
                "demandeReservation": "boolean",
                "commentaire": "string",
                "codeRefSessionModeRealisation": "string",
                "libelleRefSessionModeRealisation": "string",
                "estHorsFormation": "boolean",
                "agencePilote": {
                    "codeAgence": "string"
                },
                "libelleAgencePilote": "string",
                "sessionModules": [
                    {
                        "tache": {
                            "idTache": "string"
                        },
                        "moduleProduit": {
                            "idModuleMetier": "string",
                            "codeModule": "string",
                            "libelleModule": "string"
                        },
                        "dureeJours": "number",
                        "raisonSociale": "string",
                        "adresse": {
                            "type": "string", // ["ETR", "SFR", "CFR"]
                            "adresse2": "string",
                            "adresse3": "string",
                            "adresse4": "string",
                            "adresse5": "string",
                            "codePostal": "string",
                            "localiteDestination": "string",
                            "codePays": "string",
                            "libellePays": "string",
                            "codeCommune": "string",
                            "libelleCommune": "string",
                            "referenceExterneAdresse": "string",
                            "longitude": "number",
                            "latitude": "number",
                            "codeCedex": "number",
                            "etat": "string"
                        },
                        "dateDebut": "date"
                        "dateFin": "date"
                        "formateur": {
                            "codeCollaborateur": "string"
                        },
                        "nomFormateur": "string",
                        "prenomFormateur": "string",
                        "nombrePlacesDemande": "number",
                        "codeRefSessionModeRealisation": "string",
                        "libelleRefSessionModeRealisation": "string",
                        "stagiairesIdentifies": [
                            {
                                "stagiaire": {
                                    "idStagiaire": "number"
                                },
                                "produitStageCertificatCategories": [{
                                    "codeRefProduitStageCertificatCategories": "string",
                                    "libelleRefProduitStageCertificatCategories": "string"
                                }],
                                "nom": "string",
                                "prenom": "string",
                                "dateDeNaissance": "date"
                            }
                        ]
                    }
                ]
            },
            "caracteristiquesFacturation": {
                "codeRefModeFacturation": "string",
                "libelleRefModeFacturation": "string",
                "eligibleFacturationAuto": "boolean",
                "codeRefTauxTva": "string",
                "libelleRefTauxTva": "string",
                "codeRefDelaiPaiement": "string",
                "libelleRefDelaiPaiement": "string",
                "codeRefModePaiement": "string",
                "libelleRefModePaiement": "string",
                "numeroFranchiseTVA": "string",
                "tauxAcompte": "number"
            }
        }
    ],
    "acteurs": [{
        "pourcentage": "number",
        "montantHT": "number",
        "codeCollaborateur": "string",
        "codeRefCollaborateurRole": "string"
    }],
    "reponse": {
        "dateReponseClient": "date",
        "dateSignature": "date",
        "numeroBonCommande": "string",
        "codeRefOffreMotifRefus": "string",
        "codeRefConcurrent": "string",
        "montantConcurrence": "number"
    },
    "relationRoles": [
        {
            "relation": {
                "idRelation": "string"
            },
            "raisonSociale": "string",
            "adresse": {
                "type": "string", // ["ETR", "SFR", "CFR"]
                "adresse2": "string",
                "adresse3": "string",
                "adresse4": "string",
                "adresse5": "string",
                "codePostal": "string",
                "localiteDestination": "string",
                "codePays": "string",
                "libellePays": "string",
                "codeCommune": "string",
                "libelleCommune": "string",
                "referenceExterneAdresse": "string",
                "longitude": "number",
                "latitude": "number",
                "codeCedex": "number",
                "etat": "string"
            },
            "SIRET": "string",
            "codeRefRelationRole": "string",
            "moyensContacts": [{
                "contact": {
                    "idContact": "string"
                },
                "selectionMoyensCommunications": {
                    "moyenCommunicationParDefaut": "boolean",
                    "communiquerParMail": "boolean",
                    "typeDestinataire": "string",
                    "libelleTypeDestinataire": "string",
                    "communiquerParTelephone": "boolean",
                    "communiquerParFax": "boolean",
                    "communiquerParCourrier": "boolean"
                },
                "nom": "string",
                "prenom": "string",
                "fonction": "string"
            }],
            "selectionMoyensCommunications": {
                "moyenCommunicationParDefaut": "boolean",
                "communiquerParMail": "boolean",
                "typeDestinataire": "string",
                "libelleTypeDestinataire": "string",
                "communiquerParTelephone": "boolean",
                "communiquerParFax": "boolean",
                "communiquerParCourrier": "boolean"
            }
        }
    ],
    "tracesEnregistrements": [{
        "operation": "string", // ["C", "M", "D"]
        "date": "date",
        "utilisateur": "string"
    }]
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-offre">
                            Delete Offre
                            <a href="#request-delete-offre"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete Offre</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-offre-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-offre-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-offre-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/exposee/v1/offre/{{idOffre}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-offre-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/exposee/v1/offre/{{idOffre}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-create-facture">
                            Create or Update Factures
                            <a href="#request-create-facture"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>create new Facture or update a Facture with same idEcheance.idEcheance</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-create-facture-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-create-facture-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-create-facture-example-curl">
                                    <pre><code class="hljs curl">curl -X POST -d '
{
    "idEcheance": {
        "idEcheance": {
            "type": "string",
            "minLength": 1,
            "maxLength": 25
        }
    },
    "idEcheanceReference": {
        "idEcheance": {
            "type": "string",
            "minLength": 1,
            "maxLength": 25
        }
    },
    "mission": {
        "idMission": {
            "type": "string",
            "minLength": 1,
            "maxLength": 25
        }
    },
    "codeRefFactureClientType": {
        "type": "string",
        "minLength": 1,
        "maxLength": 4,
        "description": "F or A: F Facture, A Avoir"
    },
    "dateFacturationPrevue": {
        "type": "string",
        "format": "date"
    },
    "numeroFacture": {
        "type": "string",
        "maxLength": 20
    },
    "siOrigine": {
        "type": "string",
        "default": "A0",
        "minLength": 1,
        "maxLength": 2
    },
    "dateFacture": {
        "type": "string",
        "format": "date"
    },
    "periodeFacturation": {
        "idPeriodeFacturation": {
            "type": "string",
            "maxLength": 20
        }
    },
    "estFactureGroupee": {
        "type": "boolean",
        "default": false
    },
    "echeanceGroupee": [
        {
            "idEcheance": {
                "type": "string",
                "minLength": 1,
                "maxLength": 25
            }
        }
    ],
    "codeRefFactureClientNature": {
        "type": "string",
        "minLength": 1,
        "maxLength": 2
    },
    "estFactureInterne": {
        "type": "boolean"
    },
    "estFactureGenereeAutomatiquement": {
        "type": "boolean"
    },
    "societe": {
        "codeSociete": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4
        }
    },
    "unitePiloteFacturation": {
        "codeUniteAgence": {
            "type": "string",
            "minLength": 1,
            "maxLength": 5
        }
    },
    "uniteGestion": {
        "codeUniteAgence": {
            "type": "string",
            "minLength": 1,
            "maxLength": 5
        }
    },
    "collaborateurPiloteFacturation": {
        "codeCollaborateur": {
            "type": "string",
            "minLength": 1,
            "maxLength": 10
        }
    },
    "numeroBonCommande": {
        "type": "string",
        "maxLength": 50
    },
    "dateBonCommande": {
        "type": "string",
        "format": "date"
    },
    "numeroBonCommandeApave": {
        "type": "string",
        "maxLength": 280
    },
    "codeReceptionClient": {
        "type": "string",
        "maxLength": 280
    },
    "codeReception": {
        "type": "string"
    },
    "referenceFournisseurClient": {
        "type": "string"
    },
    "contrat": {
        "idContrat": {
            "type": "string",
            "minLength": 1,
            "maxLength": 20
        }
    },
    "codeRefFactureModeEnvoi": {
        "type": "string",
        "minLength": 1,
        "maxLength": 2,
        "description": "C=Demat Complete, I=Demat Intérop, M=DematPush via email, P=Papier"
    },
    "codeRefFactureFournisseurDematerialisationClient": {
        "type": "string",
        "maxLength": 2
    },
    "codeRefFournisseurDematerialisationApave": {
        "type": "string",
        "default": "01"
    },
    "imputationsFacturesTaches": [
        {
            "tache": {
                "idTache": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 40
                }
            },
            "montantHT": {
                "type": "number",
                "multipleOf": 0.00001,
                "maximum": 99999999999.99999
            },
            "dateImputation": {
                "type": "string",
                "format": "date"
            }
        }
    ],
    "statutEcheanceFacture": {
        "codeRefFactureClientStatut": {
            "type": "string",
            "minLength": 1,
            "maxLength": 1
        },
        "dateChangementStatut": {
            "type": "string",
            "format": "date"
        }
    },
    "payeur": {
        "relation": {
            "idRelation": {
                "type": "string",
                "minLength": 1,
                "maxLength": 18
            }
        },
        "contact": {
            "idContact": {
                "type": "string",
                "minLength": 1,
                "maxLength": 100
            }
        }
    },
    "destinataire": {
        "relation": {
            "idRelation": {
                "type": "string",
                "minLength": 1,
                "maxLength": 18
            }
        },
        "contact": {
            "idContact": {
                "type": "string",
                "minLength": 1,
                "maxLength": 100
            }
        }
    },
    "relationSignataire": {
        "relation": {
            "idRelation": {
                "type": "string",
                "minLength": 1,
                "maxLength": 18
            }
        },
        "contact": {
            "idContact": {
                "type": "string",
                "minLength": 1,
                "maxLength": 100
            }
        }
    },
    "dossierFacturation": {
        "idDossierFacturation": {
            "type": "string",
            "minLength": 1,
            "maxLength": 20
        }
    },
    "applicationSource": {
        "type": "string",
        "minLength": 1,
        "maxLength": 3
    },
    "presentationFactureClient": {
        "codeRefFactureClientNiveauRegroupementLignes": {
            "type": "string",
            "minLength": 1,
            "maxLength": 2
        },
        "codeRefFactureClientModeleDocument": {
            "type": "string",
            "minLength": 1,
            "maxLength": 4
        },
        "versionRefFactureClientModeleDocument": {
            "type": "string",
            "minLength": 1,
            "maxLength": 5
        }
    },
    "informations": {
        "type": "string"
    },
    "libelleFacture": {
        "type": "string",
        "maxLength": 100
    },
    "codeRefMissionModeFacturation": {
        "type": "string",
        "minLength": 1,
        "maxLength": 20
    },
    "codeRefDelaiPaiement": {
        "type": "string",
        "minLength": 1,
        "maxLength": 5
    },
    "codeRefModePaiement": {
        "type": "string",
        "minLength": 1,
        "maxLength": 5
    },
    "codeImputationBudgetaire": {
        "type": "string",
        "maxLength": 7
    },
    "dematerialisationNumeroMarche": {
        "type": "string",
        "maxLength": 280
    },
    "codeMethodeCreationFacture": {
        "type": "string",
        "maxLength": 1,
        "description": "M: Manuel, A: Automatique"
    },
    "pourcentageAFacturer": {
        "type": "number"
    },
    "dateLimitePaiement": {
        "type": "string",
        "format": "date"
    },
    "codeRefLangue": {
        "type": "string",
        "default": "FR",
        "minLength": 1,
        "maxLength": 3
    },
    "codeRefDeviseVente": {
        "type": "string",
        "maxLength": 5
    },
    "codeRefDeviseFacturation": {
        "type": "string",
        "minLength": 1,
        "maxLength": 5
    },
    "tauxConversion": {
        "type": "number",
        "maximum": 9999999999.99999,
        "multipleOf": 0.00001
    },
    "codeRefSocieteIntraGroupe": {
        "type": "string",
        "maxLength": 20
    },
    "lieuIntervention": {
        "idRelation": {
            "type": "string",
            "minLength": 1,
            "maxLength": 18
        }
    },
    "dematerialisationValideurClient": {
        "type": "string",
        "maxLength": 80
    },
    "codeRefContratCadreFacture": {
        "type": "string",
        "maxLength": 4
    },
    "numeroFactureReference": {
        "type": "string",
        "maxLength": 20
    },
    "pourcentageAvoir": {
        "type": "number",
        "default": 100,
        "maximum": 100
    },
    "codeRefFactureClientMotifAvoir": {
        "type": "string",
        "maxLength": 10
    },
    "remarqueAvoir": {
        "type": "string",
        "maxLength": 1000
    },
    "montantPrevisionnelHT": {
        "type": "number",
        "multipleOf": 0.00001,
        "maximum": 99999999999.99999
    },
    "montantFactureHT": {
        "type": "number",
        "maximum": 99999999999.99999,
        "multipleOf": 0.00001
    },
    "montantTVA": {
        "type": "number",
        "maximum": 99999999999.99999,
        "multipleOf": 0.00001
    },
    "montantTTC": {
        "type": "number",
        "maximum": 99999999999.99999,
        "multipleOf": 0.00001
    },
    "cyclesDeVies": [
        {
            "idCDV": {
                "type": "string",
                "maxLength": 20
            },
            "dateCDV": {
                "type": "string",
                "format": "date-time"
            },
            "codeRefFactureClientCDVType": {
                "type": "string",
                "maxLength": 2
            },
            "description": {
                "type": "string",
                "maxLength": 1200
            },
            "collaborateurActeur": {
                "codeCollaborateur": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 10
                }
            },
            "libelleAutreActeur": {
                "type": "string",
                "maxLength": 50
            }
        }
    ],
    "tracesEnregistrements": [
        {
            "operation": {
                "type": "string",
                "enum": ["C", "M", "D"],
                "description": "Création, modification, suppression"
            },
            "date": {
                "type": "string",
                "format": "date-time"
            },
            "utilisateur": {
                "type": "string",
                "maxLength": 100
            }
        }
    ],
    "lignesFacture": [
        {
            "codeRefFactureClientNatureLignes": {
                "type": "string",
                "maxLength": 2
            },
            "mission": {
                "idMission": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 25
                }
            },
            "periodeFacturation": {
                "idPeriodeFacturation": {
                    "type": "string",
                    "maxLength": 20
                }
            },
            "tache": {
                "idTache": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 40
                }
            },
            "produit": {
                "idProduit": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 13
                }
            },
            "module": {
                "idModuleMetier": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 6
                }
            },
            "article": {
                "idArticle": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 20
                }
            },
            "quantite": {
                "type": "number",
                "multipleOf": 0.001,
                "minimum": -99999999.999,
                "maximum": 99999999.999
            },
            "uniteMesureQuantite": {
                "type": "string",
                "maxLength": 10
            },
            "prixUnitaireHT": {
                "type": "number",
                "multipleOf": 0.00001,
                "minimum": 0,
                "maximum": 99999999999.99
            },
            "pourcentageRemise": {
                "type": "number",
                "multipleOf": 0.001,
                "maximum": 100
            },
            "montantNetHT": {
                "type": "number"
            },
            "codeRefTauxTVA": {
                "type": "string",
                "maxLength": 10
            },
            "tauxTVA": {
                "type": "number",
                "maximum": 99999999999.99,
                "multipleOf": 0.01,
                "minimum": 0
            },
            "montantTVA": {
                "type": "number",
                "multipleOf": 0.00001,
                "maximum": 99999999999.99999
            },
            "montantTTC": {
                "type": "number",
                "multipleOf": 0.00001,
                "maximum": 99999999999.99999
            },
            "information": {
                "type": "string",
                "maxLength": 1000
            }
        }
    ],
    "informationsPaiement": {
        "codeRefStatutPaiement": {
            "type": "string",
            "minLength": 1,
            "maxLength": 2
        },
        "montantTTC": {
            "type": "number",
            "maximum": 99999999999.99,
            "multipleOf": 0.01
        },
        "date": {
            "type": "string",
            "format": "date"
        }
    }
}' "{{BASE_URL}}/v1/facture"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-create-facture-example-http">
                                    <pre><code class="hljs http">POST {{BASE_URL}}/v1/facture HTTP/1.1
Host: 
Content-Type: application/json

{
    "idEcheance": {
        "idEcheance": "string"
    },
    "codeRefFactureClientType": "string",
    "dateFacturationPrevue": "date",
    "siOrigine": "A0",
    "estFactureGroupee": false,
    "codeRefFactureClientNature": "string",
    "estFactureInterne": false,
    "estFactureGenereeAutomatiquement": false,
    "societe": {
        "codeSociete": "string"
    },
    "unitePiloteFacturation": {
        "codeUniteAgence": "string"
    },
    "uniteGestion": {
        "codeUniteAgence": "string"
    },
    "collaborateurPiloteFacturation": {
        "codeCollaborateur": "string"
    },
    "codeRefFactureModeEnvoi": "string",
    "statutEcheanceFacture": {
        "codeRefFactureClientStatut": "string"
    },
    "payeur": {
        "relation": {
            "idRelation": "string"
        }
    },
    "destinataire": {
        "relation": {
            "idRelation": "string"
        }
    },
    "relationSignataire": {
        "relation": {
            "idRelation": "string"
        }
    },
    "dossierFacturation": {
        "idDossierFacturation": "string"
    },
    "applicationSource": "string",
    "presentationFactureClient": {
        "codeRefFactureClientNiveauRegroupementLignes": "string",
        "codeRefFactureClientModeleDocument": "string",
        "versionRefFactureClientModeleDocument": "string"
    },
    "codeRefMissionModeFacturation": "string",
    "codeRefDelaiPaiement": "string",
    "codeRefModePaiement": "string",
    "codeRefLangue": "string",
    "codeRefDeviseFacturation": "string",
    "tauxConversion": 1.0,
    "montantFactureHT": 0,
    "montantTVA": 0,
    "montantTTC": 0,
    "lignesFacture": [
        {
            "tache": {
                "idTache": "string"
            },
            "montantHT": 0
        }
    ]
}</code></pre>
                                </div>
                            </div>
                        </div>



                        <hr>
                    </div>

                    <div class="request">

                        <h3 id="request-delete-facture">
                            Delete Facture
                            <a href="#request-delete-facture"><i class="glyphicon glyphicon-link"></i></a>
                        </h3>

                        <div>
                            <p>delete Facture</p>
                        </div>

                        <div>
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="active"><a href="#request-delete-facture-example-curl"
                                        data-toggle="tab">Curl</a>
                                </li>
                                <li role="presentation"><a href="#request-delete-facture-example-http"
                                        data-toggle="tab">HTTP</a></li>
                            </ul>
                            <div class="tab-content">
                                <div class="tab-pane active" id="request-delete-facture-example-curl">
                                    <pre><code class="hljs curl">curl -X DELETE "{{BASE_URL}}/v1/facture/{{idEcheance}}"</code></pre>
                                </div>
                                <div class="tab-pane" id="request-delete-facture-example-http">
                                    <pre><code class="hljs http">DELETE {{BASE_URL}}/v1/facture/{{idEcheance}} HTTP/1.1
Host: </code></pre>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <script src="https://code.jquery.com/jquery-2.2.2.min.js"></script>
    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script>
    <script>
        $(document).ready(function () {
            $("table:not(.table)").addClass('table table-bordered');
        });
    </script>
</body>

</html>
`;